import { Roles } from 'src/components/app/types';

export enum Permission {
  AGENT_INSIGHTS = 'agent_insights',
  AI_QA = 'ai_qa',
  AI_STUDIO = 'ai_studio',
  ASSIST = 'assist',
  DISCOVER = 'discover',
  FLAMETHROWER = 'flamethrower',
  FLAMETHROWER_WORKFLOW_BUILDER_EDIT = 'flamethrower_workflow_builder_edit',
  ACTION_BUILDER = 'action_builder',
  LOG = 'log',
  LOOKER_ANALYTICS = 'looker_analytics',
  MACRO_CONTROLS = 'macro_controls_admin',
  ORCHESTRATOR = 'orchestrator',
  PREDICT_INTENTS = 'predict_intents',
  PREDICTIONS = 'predictions_analytics',
  SOLVE = 'solve_analytics',
  SOLVE_API = 'solve_api',
  SOLVE_INSIGHTS = 'solve_insights',
  SOLVE_INSIGHTS_VIEW = 'solve_insights_view',
  SOLVE_INSIGHTS_WIP = 'solve_insights_wip',
  SOLVE_LITE = 'solve_lite',
  SOLVE_PREVIEW = 'solve_preview',
  SOLVE_VOICE = 'solve_voice',
  WORKFLOW_BUILDER = 'workflow_builder',
  WORKFLOW_BUILDER_PREVIEW = 'workflow_builder_preview',
}

export enum Environment {
  LOCAL = 'local',
  PRODUCTION = 'production',
  STAGING = 'staging',
}

export enum TablesToSort {
  ACTION_BUILDER = 'actions',
  MACRO_CONTROLS = 'macro_controls_admin_table',
  SOLVE = 'solve_table',
}

export enum Apps {
  INSIGHTS = 'insights',
}

export enum ModuleName {
  ANALYTICS = 'dashboard-analytics',
  DASHBOARD = 'dashboard',
  EMAIL_BUILDER = 'email-builder',
  FLAMETHROWER = 'flamethrower',
  SOLVE_CONFIG = 'solve-config',
  SOLVE_LITE = 'solve-lite',
}

export enum Tabs {
  ACCOUNT_SETTINGS = 'Account',
  ACTION_BUILDER = 'Action Builder',
  ACTION_BUILDER_EDIT = 'Action Builder Edit',
  ADMIN_CENTER = 'Admin Center',
  AGENT_AB_TEST = 'A/B Test',
  AGENT_QA = 'Agent QA',
  AGENT_QA_INSIGHTS = 'Agent QA Insights',
  AGENT_QA_SETUP = 'Agent QA Setup',
  AI_QA = 'AI QA Setup',
  ANSWERS = 'Assist',
  ASSIST_INSIGHTS = 'Assist Insights',
  ASSIST_NOTES = 'Notes',
  CONVERSATIONS = 'Conversations',
  DISCOVER = 'Discover',
  DISCOVER_AUTOMATION = 'Automation',
  DISCOVER_DASHBOARD = 'Dashboard',
  DISCOVER_INSIGHTS = 'Discover Insights',
  DISCOVER_TOPICS = 'All Topics',
  INTEGRATIONS = 'Integrations',
  KNOWLEDGE = 'Knowledge',
  LOG = 'Log',
  LOOKER_ANALYTICS = 'Analytics',
  MACRO_CONTROLS = 'Macro Controls',
  ORCHESTRATOR = 'Orchestrator',
  PLAN = 'Plan',
  PREDICTIONS = 'Triage',
  PREDICTIONS_SETTINGS = 'Models',
  SECURITY = 'Security',
  SETTINGS = 'Settings',
  SIMULATION_RUNS = 'Simulation runs',
  SIMULATIONS = 'Simulations',
  SOLVE = 'Solve',
  SOLVE_API_CONFIGURATION = 'Headless Configuration',
  SOLVE_CONFIGURATION = 'Configuration',
  SOLVE_DASHBOARD = 'Solve Dashboard',
  SOLVE_EMAIL_CONFIGURATION = 'Email Configuration',
  SOLVE_INSIGHT = 'Solve Insights',
  SOLVE_LITE = 'Solve Lite',
  SOLVE_PREVIEW = 'Solve Preview',
  SOLVE_TESTS = 'Test Suite',
  SSO_SETTINGS = 'SSO',
  TEAM = 'Team',
  TRIAGE_INSIGHTS = 'Triage Insights',
  WORKFLOW_BUILDER = 'Agent Builder',
  WORKFLOW_BUILDER_EDIT = 'Agent Builder Edit',
}

export const DISCOVER_ROUTE_PREFIX = '/discover' as const;
export const SOLVE_INSIGHT_ROUTE_PREFIX = '/solve-insights' as const;

export enum Routes {
  ACCOUNT_SETTINGS = '/account-settings',
  ACTION_BUILDER = '/action-builder',
  ACTION_BUILDER_EDIT = '/action-builder-edit',
  ACTION_BUILDER_EDIT_V2 = '/solve/action-builder/:actionId?',
  AGENT_AB_TESTS = '/solve/ab-tests',
  AGENT_AB_TESTS_DETAIL = '/solve/ab-tests/:abTestId',
  AGENT_INSIGHT_DETAIL = '/agent-qa/agent/:agentEmail',
  AGENT_QA = '/agent-qa',
  AGENT_QA_INSIGHTS = '/agent-qa/insights',
  AGENT_QA_SETUP = '/agent-qa/setup',
  AI_QA = '/ai-qa-setup',
  ASSIST_CONFIGURATION = '/assist/configuration',
  ASSIST_INSIGHTS = '/assist/insights',
  ASSIST_INSIGHTS_INSIGHT_CARD = '/assist/insights/cards/:cardId?',
  ASSIST_INSIGHTS_AGENT_DETAIL = '/assist/insights/agent/:agentEmail',
  ASSIST_INSIGHTS_INSIGHT_CARD_VIEW = '/assist/insights/card-view/:cardId',
  ASSIST_LOGIN = '/assist-login',
  ASSIST_NOTES = '/assist/notes',
  ASSIST_PREVIEW = '/assist/preview',
  ASSIST_WORKFLOW_BUILDER = '/assist/workflow-builder',
  AUTONOMOUS_AGENT_PREVIEW = '/solve/preview/:intentId?',
  CLI_LOGIN = '/cli-login',
  CREATE_PASSWORD = '/create-password',
  DISCOVER_AUTOMATION = '/discover/automation',
  DISCOVER_DASHBOARD = '/discover/dashboard',
  DISCOVER_INSIGHTS = '/discover/insights',
  DISCOVER_TOPIC_DETAIL = '/discover/topic/:topicId',
  DISCOVER_TOPICS = '/discover/topics',
  FORGOT_PASSWORD = '/forgot-password',
  HC_REDIRECT = '/hc-redirect',
  HOMEPAGE = '/',
  INTEGRATIONS = '/integrations',
  KNOWLEDGE = '/solve/knowledge',
  LOG = '/log',
  LOGIN = '/login',
  LOGOUT = '/logout',
  LOOKER_ANALYTICS = '/analytics/:dashboardId',
  MACRO_CONTROLS = '/macro-controls',
  MAGIC_LINK = '/magic-link',
  ORCHESTRATOR = '/orchestrator',
  ORCHESTRATOR_DETAIL = '/orchestrator/:workflowId',
  ORCHESTRATOR_TEST = '/orchestrator-test/:workflowId',
  ORG_NOT_FOUND = '/org-not-found',
  PLAN = '/plan',
  PREDICT_INTENTS = '/predict-intents',
  PREDICT_INTENTS_TEST_DETAIL = '/predict-intents/tests/:intentTestId',
  PREDICTIONS_SETTINGS = '/triage-settings',
  PREDICTIONS_SETTINGS_DETAIL = '/triage-settings/:name',
  SECURITY = '/security',
  SIGN_UP = '/signup',
  SINGLE_SIGN_ON = '/single-sign-on',
  SOLVE = '/solve-analytics',
  SOLVE_API_CONFIGURATION = '/solve/api-configuration',
  SOLVE_CONFIGURATION = '/solve-configuration',
  SOLVE_EMAIL_CONFIGURATION = '/solve/email-configuration',
  SOLVE_INSIGHTS_ARTICLE_DETAIL = '/solve-insights/articles/:articleId',
  SOLVE_INSIGHTS_CONVERSATION_DETAIL = '/solve-insights/conversation/:conversationId',
  SOLVE_INSIGHTS_INSIGHT_CARD = '/solve-insights/cards/:cardId?',
  SOLVE_INSIGHTS_INSIGHT_CARD_VIEW = '/solve-insights/card-view/:cardId',
  SOLVE_INSIGHTS_MAIN = '/solve-insights',
  SOLVE_INSIGHTS_TOPIC_DETAIL = '/solve-insights/topic/:topicId',
  SOLVE_INSIGHTS_TOPIC_DETAIL_PARENT = '/solve-insights/topic/parent/:topicId',
  SOLVE_INSIGHTS_WORKFLOW_DETAIL = '/solve-insights/workflow/:workflowId',
  SOLVE_LITE = '/solve-lite',
  SOLVE_PREVIEW = '/solve-preview',
  SOLVE_TESTS = '/solve/tests',
  SSO_SETTINGS = '/sso-settings',
  TEAM = '/team',
  TRIAGE_INSIGHTS = '/triage-insights',
  TRIAGE_MODELS = '/triage-settings/models/:modelId',
  TRIAGE_SIMULATION_RUNS = '/triage-simulations',
  TRIAGE_SIMULATION_RUNS_DETAIL = '/triage-simulations/:modelId',
  TRIAGE_VERSION_CONTROL = '/triage-settings/version-control/:modelId',
  TRIAL_EXPIRED = '/trial-expired',
  WIDGET_CONFIGURATION = '/widget-configuration',
  WORKFLOW_BUILDER = '/workflow-builder',
  WORKFLOW_BUILDER_EDIT = '/workflow-builder-edit',
  WORKFLOW_BUILDER_EDIT_EMAIL_PREVIEW = '/workflow-builder-edit/email-preview',
  WORKFLOW_BUILDER_PREVIEW = '/workflow-builder-preview/:channel',
}

export enum AnswersReports {
  ACTIVE_AGENTS = 'active_agents',
  ENGAGED_TICKETS = 'engaged_tickets',
}

export enum ChartClassNames {
  ACTIVE_AGENTS = '.active-agents-line-chart',
  ENGAGED_TICKETS = '.engaged-tickets-line-chart',
}

export enum InitialsIconColors {
  BLUE = 'blue',
  COAL = 'coal',
  DARK_BLUE = 'dark-blue',
  DEEP_GRAY = 'deep-gray',
  GREEN = 'green',
  ICE_CREAM = 'ice-cream',
  MAGENTA = 'magenta',
  ORANGE = 'orange',
  PURPLE = 'purple',
  RED = 'red',
  SALMON = 'salmon',
  TEAL = 'teal',
  UNKNOWN_AGENT = 'unknown-agent',
  VIOLET = 'violet',
  YELLOW = 'yellow',
}

export enum ViewModes {
  CHART = 'Chart',
  TABLE = 'Table',
}

export enum TimeFrameFilters {
  DAILY = 'Daily',
  MONTHLY = 'Monthly',
  WEEKLY = 'Weekly',
}

export enum ErrorBookmarkToast {
  ICONCLASS = 'ToastNotification-errorIcon',
  TOASTCLASS = 'ToastNotification-bookmarkError',
  TOASTMESSAGE = "You've reached the maximum amount of starred reports.",
}

export enum linkCopiedToast {
  ICONCLASS = 'ToastNotification-copyLinkIcon',
  TOASTCLASS = 'ToastNotification-linkCopied',
  TOASTMESSAGE = 'URL copied to clipboard.',
}

export enum MacroUpdateErrorToast {
  ICONCLASS = 'iconError',
  TOASTCLASS = 'macroErrorToast',
  TOASTMESSAGE = 'This macro was recently updated. The latest changes are now displayed.',
}

export enum MacroSucessToast {
  ICONCLASS = 'iconSuccess',
  TOASTCLASS = 'macroSuccessToast',
  TOASTMESSAGE = 'Your macro has been successfully activated.',
}

export enum InvalidEmailToast {
  ICONCLASS = 'invalidEmailIcon',
  TOASTCLASS = 'invalidEmailToast',
  TOASTMESSAGE = 'Please enter a valid email',
}

export enum DuplicateEmailToast {
  ICONCLASS = 'invalidEmailIcon',
  TOASTCLASS = 'invalidEmailToast',
  TOASTMESSAGE = 'This email has already been added',
}

export enum TypesOfToast {
  BOOKMARK_TOAST = 'bookmark_toast',
  DUPLICATE_EMAIL = 'duplicate email',
  INVALID_EMAIL = 'invalid email',
  LINK_COPIED = 'link copied',
  MACRO_DEACTIVATION_SUCCESS = 'macro deactivation success',
  MACRO_UPDATE_ERROR = 'macro update error',
  MACRO_UPDATE_SUCCESS = 'macro update success',
}

export enum URL {
  PATH = '/assist',
  URL_REPORT_KEY = '#report_id=',
  URL_UNSAVED_REPORT_KEY = '#unsaved_report=',
}

export const redirectMap: any = {};

export enum UserRoles {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_AGENT = 'ROLE_AGENT',
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ROLE_USER = 'ROLE_USER',
}

export enum noDataViewProps {
  ANALYTICS_TIME_RANGE = 'There’s no data for this time range',
  DATE_ICON_CLASS = 'dateIcon',
  MACRO_CONTROLS = 'There is no data to dislpay',
  NO_DATA_ICON_CLASS = 'noDataIcon',
}

export enum MacroDeactivationSucessToast {
  ICONCLASS = 'iconSuccess',
  TOASTCLASS = 'macroSuccessToast',
  TOASTMESSAGE = 'Your macro has been successfully deactivated.',
}

/**
 * NOTE: SUPER_ADMIN ONLY
 * Organizaion selected by the user that's stored in localStorage
 * */
export function getSelectedOrganizationForSuperAdmin() {
  try {
    const orgAsString = localStorage.getItem('org');
    if (orgAsString) {
      return JSON.parse(orgAsString);
    }
  } catch {}

  return null;
}

/** User role that's stored in localStorage */
export const getUserRole = () => localStorage.getItem('userRole') as Roles;

export enum SolveChannels {
  API = 'api',
  EMAIL = 'email',
  WIDGET = 'widget',
}

export enum ExpressionTypes {
  BOOLEAN_AGGREGATOR = 'boolean_aggregator',
  FILTER = 'filter',
}

export enum StepTypes {
  ARTICLE = 'article',
  ARTICLE_SUGGESTION = 'article_suggestion',
  ATTACHMENT_ANALYSIS_UPLOAD = 'attachment_analysis_upload',
  ATTACHMENT_UPLOAD = 'attachment_upload',
  BUTTONS = 'buttons',
  CODE_BLOCK = 'code_execution',
  COMM_100_CHAT_HANDOFF = 'comm_100_chat_handoff',
  CONDITION = 'condition',
  CONTACTME_CHAT_HANDOFF = 'contactme_chat_handoff',
  CONVERSATION_OAUTH_SIGN_IN = 'conversation_oauth_sign_in',
  CSAT_TRIGGER_POINT = 'csat_trigger_point',
  CUSTOM_EVENT = 'custom_event',
  DYNAMIC_CARD = 'dynamic_card',
  DYNAMICS_365_CASE_CREATION = 'dynamics_365_case_creation',
  EMBED = 'embed',
  END_INTERACTIVE_EMAIL_CHAT = 'end_interactive_email_chat',
  FLAMETHROWER_API_CALL = 'flamethrower_api_call',
  FORETHOUGHT_LIVE_CHAT_HANDOFF = 'forethought_live_chat_handoff',
  FORM = 'form',
  FRESHCHAT_CHAT_HANDOFF = 'freshchat_chat_handoff',
  FRONT_CHAT_HANDOFF = 'front_chat_handoff',
  FRONT_TICKET_CREATION = 'front_ticket_creation',
  GLADLY_CHAT_HANDOFF = 'gladly_chat_handoff',
  GO_TO_COMPONENT = 'go_to_component',
  GO_TO_HANDOFF = 'go_to_handoff',
  GO_TO_INTENT = 'go_to_intent',
  GO_TO_INTENT_EMAIL = 'go_to_intent_email',
  GORGIAS_CHAT_HANDOFF = 'gorgias_chat_handoff',
  HALOCRM_TICKET_CREATION = 'halocrm_ticket_creation',
  HUBSPOT_CHAT_HANDOFF = 'hubspot_chat_handoff',
  HUBSPOT_HELPDESK_TICKET_CREATION = 'hubspot_helpdesk_ticket_creation',
  HUBSPOT_TICKET_CREATION = 'hubspot_ticket_creation',
  HYPERLINK_REDIRECT = 'hyperlink_redirect',
  IMAGE = 'image',
  INTERCOM_LIVE_CHAT = 'intercom_live_chat',
  INTERCOM_TICKET_CREATION = 'intercom_ticket_creation',
  JIRA_SERVICE_MANAGEMENT_REQUEST_CREATION = 'jira_service_management_request_creation',
  KUSTOMER_CHAT_HANDOFF = 'kustomer_chat_handoff',
  KUSTOMER_CONVERSATION_CREATION = 'kustomer_conversation_creation',
  LIVE_CHAT_CHAT_HANDOFF = 'live_chat_chat_handoff',
  MINI_AUTOFLOW_POLICY = 'mini_autoflow_policy',
  SPEECH_STEP = 'speech_step',
  PARSE_JWT = 'parse_jwt',
  PRODUCT_RECOMMENDATION = 'product_recommendation',
  PYLON_TICKET_CREATION = 'pylon_ticket_creation',
  QUIQ_CHAT_HANDOFF = 'quiq_chat_handoff',
  CALLCORP_CHAT_HANDOFF = 'callcorp_chat_handoff',
  RESTART_CONVERSATION = 'restart_conversation',
  SALESFORCE_CASE_CREATION = 'salesforce_case_creation',
  SALESFORCE_CHAT_HANDOFF = 'salesforce_chat_handoff',
  SALESFORCE_MESSAGING_HANDOFF = 'salesforce_messaging_handoff',
  SERVICENOW_CASE_CREATION = 'servicenow_case_creation',
  SERVICENOW_CASE_INCIDENT_CREATION = 'servicenow_case_incident_creation',
  SET_CONTEXT_VARIABLE = 'set_context_variable',
  SHOPIFY_TRACKING = 'shopify_tracking',
  SNAPENGAGE_CHAT_HANDOFF = 'snapengage_chat_handoff',
  SNOWFLAKE_DATA_QUERY = 'snowflake_data_query',
  SUNCO_LIVE_CHAT = 'sunco_live_chat',
  TALKDESK_CHAT_HANDOFF = 'talkdesk_chat_handoff',
  TEXT_MESSAGE = 'text_message',
  TRIGGER_EVENT = 'trigger_event',
  VARIABLE_MAPPING = 'variable_mapping',
  ZAMMAD_TICKET_CREATION = 'zammad_ticket_creation',
  ZENDESK_ATTACHMENT_UPLOAD = 'zendesk_attachment_upload',
  ZENDESK_CHAT_HANDOFF = 'zendesk_chat_handoff',
  ZENDESK_MESSAGING_HANDOFF = 'zendesk_messaging_handoff',
  ZENDESK_TICKET_CREATION = 'zendesk_ticket_creation',
}

export enum QuasiStepTypes {
  DYNAMIC_ARTICLE_SUGGESTION = 'dynamic_article_suggestion',
  FEEDBACK = 'feedback',
}

export enum ConfigErrorPrompt {
  LABEL = 'ERRORS',
  PROMPT = 'Configuration Error',
}

export enum DeleteWorkflowPrompt {
  DESCRIPTION = 'Deleting this agent will lose any data associated with it.',
  LABEL = 'WARNING',
  LEFT_BUTTON_TEXT = 'Cancel',
  PROMPT = 'Delete this agent?',
  RIGHT_BUTTON_TEXT = 'Delete',
}

export enum ContextVariableTypes {
  CHECKBOX = 'Checkbox',
  DATE = 'Date',
  DYNAMIC_LIST = 'Dynamic list',
  DYNAMIC_LIST_MULTI_SELECT = 'Multi-select dynamic list',
  EMAIL = 'Email',
  FLAT_LIST = 'File list',
  LIST = 'List',
  LONG_TEXT = 'Long text',
  MULTI_SELECT_LIST = 'Multi-select List',
  MULTIOPTIONS = 'Multi-options',
  NUMBER = 'Number',
  PHONE = 'Phone',
  SHORT_TEXT = 'Short text',
}

export enum ContextVariableTypeKeys {
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
  DYNAMIC_LIST = 'DYNAMIC_LIST',
  DYNAMIC_LIST_MULTI_SELECT = 'DYNAMIC_LIST_MULTI_SELECT',
  EMAIL = 'EMAIL',
  LIST = 'LIST',
  LONG_TEXT = 'LONG_TEXT',
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTIOPTIONS = 'MULTIOPTIONS',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  SHORT_TEXT = 'SHORT_TEXT',
}

export const DYNAMIC_OPTION_ASSIGNMENT_TYPES: (keyof typeof ContextVariableTypes)[] =
  ['MULTI_SELECT_LIST', 'LIST'];

export enum ActionBuilderActionTypes {
  API = 'api',
  ARTICLE_SUGGESTION = 'article_suggestion',
  ARTICLE_SUGGESTION_GRANULAR = 'article_suggestion_granular',
  BRAND_EMBASSY_HANDOFF = 'brand_embassy_handoff',
  BROWSER_AGENT = 'browser_agent',
  CATCH_ALL_HANDOFF = 'catch_all_handoff',
  CODE_EXECUTION = 'code_execution',
  COMM_100_CHAT_HANDOFF = 'comm_100_chat_handoff',
  CONTACTME_CHAT_HANDOFF = 'contactme_chat_handoff',
  CONTEXT_VARIABLE_MAPPING = 'context_variable_mapping',
  CONVERSATION_OAUTH_SIGN_IN = 'conversation_oauth_sign_in',
  CUSTOM_EVENT = 'custom_event',
  // a FE only type to differentiate between the draggable normal vs. dynamic article suggestion
  DYNAMIC_ARTICLE_SUGGESTION = 'dynamic_article_suggestion',
  DYNAMIC_CARD = 'dynamic_card',
  DYNAMICS_365_CASE_CREATION = 'dynamics_365_case_creation',
  END_INTERACTIVE_EMAIL_CHAT = 'end_interactive_email_chat',
  FORETHOUGHT_LIVE_CHAT_HANDOFF = 'forethought_live_chat_handoff',
  FRESHCHAT_CHAT_HANDOFF = 'freshchat_chat_handoff',
  FRESHDESK_TICKET_AND_CONTACT_CREATION = 'freshdesk_ticket_and_contact_creation',
  FRESHDESK_TICKET_CREATION = 'freshdesk_ticket_creation',
  FRONT_CHAT_HANDOFF = 'front_chat_handoff',
  FRONT_TICKET_CREATION = 'front_ticket_creation',
  GLADLY_CHAT_HANDOFF = 'gladly_chat_handoff',
  GORGIAS_CHAT_HANDOFF = 'gorgias_chat_handoff',
  GORGIAS_TICKET_CREATION = 'gorgias_ticket_creation',
  GRANULAR_ARTICLE_SUGGESTION_V2 = 'granular_article_suggestion_action_v2',
  GRANULAR_JIRA_SERVICE_MANAGEMENT_CREATE_REQUEST = 'granular_jira_service_management_create_request',
  HALOCRM_TICKET_CREATION = 'halocrm_ticket_creation',
  HUBSPOT_CHAT_HANDOFF = 'hubspot_chat_handoff',
  HUBSPOT_HELPDESK_TICKET_CREATION = 'hubspot_helpdesk_ticket_creation',
  HUBSPOT_TICKET_CREATION = 'hubspot_ticket_creation',
  HYPERLINK_REDIRECT = 'hyperlink_redirect',
  INTERCOM_HANDOFF = 'intercom_handoff',
  INTERCOM_LIVE_CHAT = 'intercom_live_chat',
  INTERCOM_TICKET_CREATION = 'intercom_ticket_creation',
  JIRA_SERVICE_MANAGEMENT_CREATE_REQUEST = 'jira_service_management_create_request',
  KUSTOMER_CHAT_HANDOFF = 'kustomer_chat_handoff',
  KUSTOMER_CONVERSATION_CREATION = 'kustomer_conversation_creation',
  KUSTOMER_HANDOFF = 'kustomer_handoff',
  LIVE_CHAT_CHAT_HANDOFF = 'live_chat_chat_handoff',
  MCP = 'mcp',
  PARSE_JWT = 'parse_jwt',
  PRODUCT_RECOMMENDATION = 'product_recommendation',
  PYLON_TICKET_CREATION = 'pylon_ticket_creation',
  QUIQ_CHAT_HANDOFF = 'quiq_chat_handoff',
  CALLCORP_CHAT_HANDOFF = 'callcorp_chat_handoff',
  SALESFORCE_CASE_CREATION = 'salesforce_case_creation',
  SALESFORCE_CHAT_HANDOFF = 'salesforce_chat_handoff',
  SALESFORCE_HANDOFF = 'salesforce_handoff',
  SALESFORCE_MESSAGING_HANDOFF = 'salesforce_messaging_handoff',
  SERVICENOW_CASE_CREATION = 'servicenow_case_creation',
  SERVICENOW_CASE_INCIDENT_CREATION = 'servicenow_case_incident_creation',
  SET_CONTEXT_VARIABLE = 'set_context_variable',
  SHOPIFY_ORDER_STATUS_TEMPLATE = 'shopify_order_status_template',
  SNAPENGAGE_CHAT_HANDOFF = 'snapengage_chat_handoff',
  SNOWFLAKE_DATA_QUERY_TEMPLATE = 'snowflake_data_query_template',
  SUNCO_LIVE_CHAT = 'sunco_live_chat',
  TALKDESK_CHAT_HANDOFF = 'talkdesk_chat_handoff',
  TEMPLATE_API = 'template_api',
  TRIGGER_EVENT = 'trigger_event',
  ZAMMAD_TICKET_CREATION = 'zammad_ticket_creation',
  ZENDESK_ATTACHMENT_UPLOAD = 'zendesk_attachment_upload',
  ZENDESK_CHAT_HANDOFF = 'zendesk_chat_handoff',
  ZENDESK_CHAT_HANDOFF_V2 = 'zendesk_chat_handoff_v2',
  ZENDESK_FLOWSTATE_ACTION = 'zendesk_flowstate_action',
  ZENDESK_HANDOFF = 'zendesk_handoff',
  ZENDESK_MESSAGING_HANDOFF = 'zendesk_messaging_handoff',
  ZENDESK_SIP_CALL = 'zendesk_sip_call',
  ZENDESK_TALK_HANDOFF = 'zendesk_talk_handoff',
  ZENDESK_TICKET_CREATION = 'zendesk_ticket_creation',
}

export enum FlamethrowerTrackingApplications {
  ACTION_BUILDER = 'action-builder',
  WORKFLOW_BUILDER = 'workflow-builder',
  WORKFLOW_BUILDER_AUTOFLOW_CANVAS = 'workflow-builder-autoflow-canvas',
  WORKFLOW_BUILDER_CANVAS = 'workflow-builder-canvas',
}

export enum FlamethrowerTrackingEventTypes {
  ACTION_CREATED = 'action-created',
  ACTION_DELETED = 'action-deleted',
  ACTION_UPDATED = 'action-updated',
  CONFIG_PROACTIVE_DISABLED = 'config-proactive-disabled',
  CONFIG_PROACTIVE_ENABLED = 'config-proactive-enabled',
  COPY_WORKFLOW_STEPS = 'copy-workflow-steps',
  DOMAIN_ADD_BUTTON = 'domain_add_button',
  DOMAIN_REMOVE_BUTTON = 'domain_remove_button',
  INTENT_ROUTING_ADDED = 'intent-routing-added',
  INTENT_TOPIC_CLICKED = 'intent-topic-clicked',
  LIVE_WORKFLOW_VERSION_SELECTED = 'live-workflow-version-selected',
  NEW_WORKFLOW_DRAFT_VERSION_SELECTED = 'new-workflow-draft-version-selected',
  PASTE_WORKFLOW_STEPS = 'paste-workflow-steps',
  RESTART_CONVERSATION_STEP_ADDED = 'restart-conversation-step-added',
  STARTER_PACK_INTENT_ADDED = 'starter-pack-intent-added',
  STARTER_PACK_INTENT_REMOVED = 'starter-pack-intent-removed',
  STARTER_PACK_INTENT_VIEWED = 'starter-pack-intent-viewed',
  STARTER_PACK_PHRASE_ADDED = 'starter-pack-phrase-added',
  STEP_LEVEL_ARTICLE_SUGGESTION_STEP_OPTION_SELECTED = 'step-level-article-suggestion-step-option-selected',
  STEP_LEVEL_BUTTON_STEP_OPTION_SELECTED = 'step-level-button-step-option-selection',
  STEP_LEVEL_METRICS_BUTTON_CLICKED = 'step-level-metrics-button-clicked',
  WORKFLOW_ACTION_ADDED = 'workflow-action-added',
  WORKFLOW_ACTION_DELETED = 'workflow-action-deleted',
  WORKFLOW_ACTION_EDITED = 'workflow-action-edited',
  WORKFLOW_ACTIVATED = 'workflow-activated',
  WORKFLOW_ADDED_ARTICLE = 'workflow-added-article',
  WORKFLOW_ADDED_ARTICLE_SUGGESTION = 'workflow-added-article-suggestion',
  WORKFLOW_ADDED_BUTTON_STEP = 'workflow-added-button-step',
  WORKFLOW_ADDED_CONDITIONS_STEP = 'workflow-added-conditions-step',
  WORKFLOW_ADDED_EMBED_STEP = 'workflow-added-embed-step',
  WORKFLOW_ADDED_FORM_STEP = 'workflow-added-form-step',
  WORKFLOW_ADDED_IMAGE = 'workflow-added-image',
  WORKFLOW_ADDED_TEXT_STEP = 'workflow-added-text-step',
  WORKFLOW_ADDED_TEXT_STEP_OVER_50_WORDS = 'workflow-added-text-step-over-50-words',
  WORKFLOW_ADDED_TEXT_STEP_WITH_LINK = 'workflow-added-text-step-with-link',
  WORKFLOW_CREATED = 'workflow-created',
  WORKFLOW_CUSTOM_EVENT_ACTION_ADDED = 'workflow-custom-event-action-added',
  WORKFLOW_DEACTIVATED = 'workflow-deactivated',
  WORKFLOW_DELETED = 'workflow-deleted',
  WORKFLOW_DYNAMICS_365_CASE_CREATION_ACTION_ADDED = 'workflow-dynamics-365-case-creation-action-added',
  WORKFLOW_EDITING_BEGAN = 'workflow-editing-began',
  WORKFLOW_FRONT_TICKET_CREATION_ACTION_ADDED = 'workflow-front-ticket-creation-action-added',
  WORKFLOW_GENERIC_HANDOFF_ACTION_ADDED = 'workflow-generic-handoff-action-added',
  WORKFLOW_HALOCRM_TICKET_CREATION_ACTION_ADDED = 'workflow-halocrm-ticket-creation-action-added',
  WORKFLOW_INTERCOM_TICKET_CREATION_ACTION_ADDED = 'workflow-intercom-ticket-creation-action-added',
  WORKFLOW_JIRA_HANDOFF_ACTION_ADDED = 'workflow-jira-handoff-action-added',
  WORKFLOW_KUSTOMER_CHAT_HANDOFF_ACTION_ADDED = 'workflow-kustomer-chat-handoff-action-added',
  WORKFLOW_KUSTOMER_CONVERSATION_CREATION_ACTION_ADDED = 'workflow-kustomer-conversation-creation-action-added',
  WORKFLOW_PYLON_TICKET_CREATION_ACTION_ADDED = 'workflow-pylon-ticket-creation-action-added',
  WORKFLOW_OUTLINE_ITEM_CLICKED = 'workflow-outline-item-clicked',
  WORKFLOW_OUTLINE_REFRESH_CLICKED = 'workflow-outline-refresh-clicked',
  WORKFLOW_OUTLINE_TAB_CLICKED = 'workflow-outline-tab-clicked',
  WORKFLOW_SALESFORCE_CASE_CREATION_ACTION_ADDED = 'workflow-salesforce-case-creation-action-added',
  WORKFLOW_SALESFORCE_CHAT_HANDOFF_ACTION_ADDED = 'workflow-salesforce-chat-handoff-action-added',
  WORKFLOW_SALESFORCE_HANDOFF_ACTION_ADDED = 'workflow-salesforce-handoff-action-added',
  WORKFLOW_SERVICENOW_CASE_CREATION_ACTION_ADDED = 'workflow-servicenow-case-creation-action-added',
  WORKFLOW_SERVICENOW_CASE_INCIDENT_CREATION_ACTION_ADDED = 'workflow-servicenow-case-incident-creation-action-added',
  WORKFLOW_STEP_AND_BELOW_DELETED = 'workflow-step-and-below-deleted',
  WORKFLOW_STEP_DELETED = 'workflow-step-deleted',
  WORKFLOW_STEP_EDITED = 'workflow-step-edited',
  WORKFLOW_SUGGESTED_INTENT_ADDED = 'workflow-suggested-intent-added',
  WORKFLOW_VERSION_CONTROL_PANEL_OPENED = 'workflow-version-control-panel-opened',
  WORKFLOW_ZAMMAD_TICKET_CREATION_ACTION_ADDED = 'workflow-zammad-ticket-creation-action-added',
  WORKFLOW_ZENDESK_CHAT_HANDOFF_ACTION_ADDED = 'workflow-zendesk-chat-handoff-action-added',
  WORKFLOW_ZENDESK_HANDOFF_ACTION_ADDED = 'workflow-zendesk-handoff-action-added',
  WORKFLOW_ZENDESK_TICKET_CREATION_ACTION_ADDED = 'workflow-zendesk-ticket-creation-action-added',
}

export enum SolveConfigurationTypes {
  API = 'api',
  EMAIL = 'email',
  HANDOFF = 'handoff',
  KNOWLEDGE = 'knowledge',
  PLAYBOOK = 'playbook',
  SLACK = 'slack',
  VOICE = 'voice',
  WIDGET = 'widget',
}

export enum SolveConfigTrackingEventTypes {
  ADD_CUSTOM_URL_FOR_KNOWLEDGE_BASE = 'add-custom-url-for-knowledge-base',
  CONFIGURATION_DISCARDED = 'configuration-discarded',
  CONFIGURATION_PUBLISHED = 'configuration-published',
  CONFIGURATION_UPDATE = 'configuration-update',
  CONNECT_KNOWLEDGE_BASE = 'connect-knowledge-base',
  NAVIGATE_TO_INTEGRATIONS_PAGE = 'navigate-to-integrations-page',
  PLAYBOOK_CONFIGURATION_PUBLISHED = 'playbook-configuration-published',
  TAB_NAVIGATION = 'tab-navigation',
  VOICE_CONFIGURATION_PUBLISHED = 'voice_configuration-published',
  VOICE_PREVIEW = 'voice-preview',
  WIDGET_ACTIVATED = 'widget-activated',
  WIDGET_DEACTIVATED = 'widget-deactivated',
  WIDGET_PREVIEW = 'widget-preview',
}

export enum DragNDrops {
  FT_ACTION = 'ft-action',
  FT_ARTICLE = 'ft-article',
  FT_INTENT = 'ft-intent',
  FT_RESTART = 'ft-restart',
}

export enum RevampedDragNDrops {
  REVAMPED_FT_ACTION = 'revamped-ft-action',
  REVAMPED_FT_ARTICLE = 'revamped-ft-article',
  REVAMPED_FT_INTENT = 'revamped-ft-intent',
  REVAMPED_FT_NON_SQUEEZE_ACTION = 'revamped-ft-non-squeeze-action',
  REVAMPED_FT_RESTART = 'revamped-ft-restart',
}

export enum WorkflowMetricsTimePeriods {
  ALL_TIME = 'all_time',
  SEVEN_DAYS = 'seven_days',
  THIRTY_DAYS = 'thirty_days',
}

export enum ElasticSearchDataType {
  BOOLEAN = 'boolean',
  DOUBLE = 'double',
  FLOAT = 'float',
  INTEGER = 'integer',
  IP = 'ip',
  KEYWORD = 'keyword',
  LONG = 'long',
  NULL = 'null',
  TEXT = 'text',
  UNSIGNED_LONG = 'unsigned_long',
  VERSION = 'version',
}

export enum CommonIntentWorkflowType {
  FALLBACK = 'Fallback',
  GENERAL_HANDOFF = 'general-handoff',
  HANDOFF = 'Handoff',
  KNOWLEDGE_ARTICLE = 'Knowledge_Article',
}

export enum TranslationsTableMode {
  DRAFT = 'draft',
  LIVE = 'live',
}

export enum APITemplateTypes {
  HUBSPOT_CREATE_CONTACT_TEMPLATE = 'hubspot_create_contact_template',
}

export enum ExportableTableType {
  INSIGHT_AGENT_TICKETS_TABLE = 'insight_agent_tickets_table',
  INSIGHT_AGENTS_TICKETS_TABLE = 'insight_agents_tickets_table',
  INSIGHT_ARTICLES_TABLE = 'insight_articles_table',
  INSIGHT_ASSIST_CHATS_TABLE = 'insight_assist_chats_table',
  INSIGHT_CHATS_TABLE = 'insight_chats_table',
  INSIGHT_EMAIL_ARTICLES_TABLE = 'insight_email_articles_table',
  INSIGHT_EMAIL_CHATS_TABLE = 'insight_email_chats_table',
  INSIGHT_TOPICS_TABLE = 'insight_topics_table',
  INSIGHT_WORKFLOWS_TABLE = 'insight_workflows_table',
}
